import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/core/alert/alert.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { StorageService } from 'src/app/core/helpers/storage.service';
import { MsalService } from 'src/app/core/msal.service';

@Component({
  standalone: false,
  selector: 'app-verify-invite',
  templateUrl: './verify-invite.component.html',
  styleUrls: ['./verify-invite.component.scss']
})
export class VerifyInviteComponent implements OnInit {


  isLoading$: boolean;

  constructor(
    private authService: AuthService,
    private router: Router,
    private msal: MsalService,
    public alertService: AlertService,
    public storageService: StorageService
  ) { }
  ngOnInit() {
    this.msal.loadingStatus.subscribe((data) => (this.isLoading$ = data));
    this.isLoading$ = false;
    this.storageService.removeAll();
  }

  verify() {
    this.isLoading$ = true;
    this.msal.microsoftSignIn('verification');
  }

}
